import React, { useRef, useEffect } from 'react';
import { bool, node, number, string } from 'prop-types';

import Loading from '../components/loading';

function LoadingWrapper({
  loading,
  refreshed,
  children,
  withInitialLoading = false,
  className = '',
  width,
  height
}) {
  const initialLoading = useRef(withInitialLoading);
  useEffect(() => {
    if (initialLoading.current && loading) {
      initialLoading.current = false;
    }
  }, [loading]);
  return initialLoading.current || (loading && !refreshed) ? (
    <Loading className={className} width={width} height={height} />
  ) : (
    <>{children}</>
  );
}

LoadingWrapper.propTypes = {
  loading: bool.isRequired,
  children: node,
  className: string,
  height: number,
  refreshed: bool,
  width: number,
  withInitialLoading: bool
};

export default LoadingWrapper;
